<template>
  <div class="post-header">
    <h1 class="post-header-title">{{title}}</h1>
    <h2 class="post-header-subtitle">{{subtitle}}</h2>
    <div class="post-header-highlight">
      <img class="post-header-highlight__image" :src="image +'?x=' + Date.now()" />
      <span class="post-header-highlight__credits">
        {{credits}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'title',
    'image',
    'credits',
    'subtitle',
  ],
};
</script>

<style lang="scss">
.post-header {
  position: relative;

  width: 100%;

  margin-bottom: rem-calc(40);

  @media #{$medium-up} {
    margin-bottom: rem-calc(15);
  }
}

.post-header-title {
  margin: 0;

  color: $white;
  font-size: rem-calc(18);
  font-family: $font-family--header;

  @media #{$medium-up} {
    font-size: rem-calc(40);
  }
}

.post-header-subtitle {
  margin: rem-calc(10 0);

  color: $white;
  font-size: rem-calc(15);
  font-family: 'oxfam-regular';
  font-weight: normal;

  @media #{$medium-up} {
    margin: rem-calc(20 0 30);
    font-size: rem-calc(20);
  }
}

.post-header-highlight {
  position: relative;

  width: 100%;
  padding-top: 50%;

  overflow: hidden;
}

.post-header-highlight__image {
  position: absolute;

  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;

  object-fit: cover;
  transform: translate(-50%, -50%);
}

.post-header-highlight__credits {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;

  padding: rem-calc(5 0);

  font-size: rem-calc(14);
  text-align: right;

  z-index: 1;
  background-color: $white;
}
</style>
